<template>
    <div>
        评估项列表
    </div>
</template>

<script>
    export default {
        name: "Page"
    }
</script>

<style scoped>

</style>